import React from 'react';
import { Button, Modal } from 'antd-v5';

const StoreModal = ({ open, onClose, stores, handleStore, clientName, lastMessageStoreId, selectedStore }) => {
  const getStoreName = storeId => {
    if (!stores || !storeId) return 'Unknown Store';
    const findStore = stores.find(store => store.id === storeId);
    return findStore ? findStore.name : 'Unknown Store';
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={400}
      title={`${clientName} messaged ${getStoreName(lastMessageStoreId)}.`}
    >
      <div className="flex-col-center gap-16 w-100-P">
        <span className="align-text-left w-100-P">
          {'You are currently in '} <strong>{`${getStoreName(selectedStore)}'s`}</strong>
          {' inbox.'}
        </span>
        <span className="align-text-left w-100-P">Which number would you like to reply from?</span>
        <div className="flex-row-spacebetween-nowrap w-100-P">
          <Button type="primary" onClick={() => handleStore(lastMessageStoreId)} style={{ width: '100%' }}>
            {getStoreName(lastMessageStoreId)}
          </Button>
          <Button type="primary" onClick={() => handleStore(selectedStore)} style={{ width: '100%' }}>
            {getStoreName(selectedStore)}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default StoreModal;
